import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';
import { getQuery } from '@/helpers/utils';

export const complianceService = {
  notifications: () => axios.get(Pathes.Compliance.notifications),
  dismissNotification: caseId => axios.post(Pathes.Compliance.notificationDismiss(caseId)),
  detail: caseId => axios.get(`${Pathes.Compliance.complianceForm}${getQuery({ case_id: caseId })}`),
  submitCase: payload => axios.post(Pathes.Compliance.complianceForm, payload),
};
